import { withErrorBoundary, getCurrentUserHook } from '@nile/components';
import useAINotificationHook from '@nile/components/src/Components/AI/hooks/useAINotificationHook';
import React, { useEffect } from 'react';
import { DisplayText } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import DefaultAINotification from './DefaultAINotification';

const AINotifications = () => {
  const {
    notifications,
    getInitialNotificationCount
  } = useAINotificationHook();
  const currentUser = getCurrentUserHook();
  const userName = currentUser?.name;
  const count = notifications?.length || 0;

  // In notification we'll have constant and name.
  // We may have multiple notifications name for same constant
  // This map will return the component based on the constant and name
  const NOTIFICATION_COMPONENT_MAP = {};
  useEffect(() => {
    getInitialNotificationCount();
  }, []);


  if (notifications?.length > 0) {
    return (
      <>
        <div className="mb5">
          <DisplayText element="p" size="large" weight="Medium">
            <FormattedMessage id="onboarding.hey" /> {userName}
          </DisplayText>
        </div>
        <div id="ai-notification-wrapper" className="mb20 mb20 flex col g10">
          {notifications.map((notification) => {
            const constant = notification?.aiFeature?.constant;
            const name = notification?.aiFeature?.name;
            const agentNotificationCount = notification?.count;
            const NotifcationComponent =
              NOTIFICATION_COMPONENT_MAP?.[constant]?.[name];
            if (NotifcationComponent) {
              return (
                <NotifcationComponent
                  count={agentNotificationCount}
                  name={name}
                />
              );
            }
            return (
              <DefaultAINotification
                count={agentNotificationCount}
                name={name}
                constant={constant}
              />
            );
          })}
        </div>
      </>
    );
  }
};

export default withErrorBoundary(AINotifications);
